// Generated by CoffeeScript 2.7.0
var Duration;

import {
  getZH_CN
} from 'helpers/i18n.js';

Duration = (function() {
  var DATE_COMPONENT, DATE_TO_PART, PERIOD_MARKER, TIME_COMPONENT, TIME_MARKER, TIME_TO_PART;

  class Duration {
    constructor({years, months, weeks, days, hours, minutes, seconds} = {}, enableLimitRange = false) {
      this.years = years;
      this.months = months;
      this.weeks = weeks;
      this.days = days;
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
      this.enableLimitRange = enableLimitRange;
      this.years = this._parseLength(this.years);
      this.months = this._parseLength(this.months);
      this.weeks = this._parseLength(this.weeks);
      this.days = this._parseLength(this.days);
      this.hours = this._parseLength(this.hours);
      this.minutes = this._parseLength(this.minutes);
      this.seconds = this._parseLength(this.seconds);
      this.direction = 1;
      if (this.enableLimitRange) {
        this._limitRange();
      }
    }

    static parse(str, enable_limit_range = false) {
      var date_part, date_str, duration, i, j, len, len1, length, part, ref, ref1, time_part, time_str;
      if (!PERIOD_MARKER.test(str)) {
        throw new Error('Invalid duration');
      }
      str = str.toUpperCase();
      duration = new Duration({}, enable_limit_range);
      duration.direction = /^-/.test(str) ? -1 : 1;
      str = str.replace(PERIOD_MARKER, '');
      [date_part, time_part] = str.split(TIME_MARKER);
      if (date_part != null ? date_part.length : void 0) {
        ref = date_part.match(DATE_COMPONENT);
        for (i = 0, len = ref.length; i < len; i++) {
          date_str = ref[i];
          length = duration._parseLength(date_str);
          part = DATE_TO_PART[date_str.replace(length, '')];
          if (part) {
            duration.set(part, length);
          }
        }
      }
      if (time_part != null ? time_part.length : void 0) {
        ref1 = time_part.match(TIME_COMPONENT);
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          time_str = ref1[j];
          length = duration._parseLength(time_str);
          part = TIME_TO_PART[time_str.replace(length, '')];
          if (part) {
            duration.set(part, length);
          }
        }
      }
      if (duration.enableLimitRange) {
        duration._limitRange();
      }
      return duration;
    }

    set(attribute_name, length) {
      return this[attribute_name] = length;
    }

    iso8601() {
      var str;
      str = 'P';
      str = this._serializePart(str, DATE_TO_PART);
      if (this.hours + this.minutes + this.seconds > 0) {
        str = `${str}T`;
      }
      str = this._serializePart(str, TIME_TO_PART);
      return str;
    }

    humanText() {
      return _.reduce(['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'], (memo, key) => {
        if (this[key]) {
          memo += `${this[key]}${getZH_CN('date.unit.' + key)}`;
        }
        return memo;
      }, '');
    }

    _limitRange() {
      return _.reduce([['seconds', 60], ['minutes', 60], ['hours', 24], ['days']], (carry, item) => {
        this[item[0]] += carry;
        // 如果没有向上的进制，则结束
        if (!item[1]) {
          return;
        }
        carry = parseInt(this[item[0]] / item[1]);
        this[item[0]] = this[item[0]] % item[1];
        return carry;
      }, 0);
    }

    _serializePart(str, part_obj) {
      var attribute_name, part;
      for (part in part_obj) {
        attribute_name = part_obj[part];
        if (this[attribute_name]) {
          str = `${str}${this[attribute_name]}${part}`;
        }
      }
      return str;
    }

    _parseLength(length) {
      return parseInt(length) || 0;
    }

  };

  PERIOD_MARKER = /^(?:-)?P/;

  TIME_MARKER = /T/;

  DATE_COMPONENT = /([\d\.]+(Y|M|D|W))/g;

  TIME_COMPONENT = /([\d\.]+(H|M|S))/g;

  DATE_TO_PART = {
    Y: 'years',
    M: 'months',
    W: 'weeks',
    D: 'days'
  };

  TIME_TO_PART = {
    H: 'hours',
    M: 'minutes',
    S: 'seconds'
  };

  return Duration;

}).call(this);

window.Duration = Duration;
